import React from "react";
import { CircleHelp } from "lucide-react";
import "./RecipesAdmin.css";

const RecipeSectionHelp = ({
  title = "How to use this section",
  children,
  defaultOpen = false,
}) => (
  <details className="recipe-section-help" open={defaultOpen || undefined}>
    <summary>
      <span>
        <CircleHelp size={17} /> {title}
      </span>
      <small>Open guide</small>
    </summary>
    <div className="recipe-section-help-content">{children}</div>
  </details>
);

export default RecipeSectionHelp;
